document.addEventListener("DOMContentLoaded", function () {
  const housingUnits = document.querySelectorAll(".housing-unit");
  const button = document.getElementById("add-housing-unit");

  if (!housingUnits.length || !button) return;

  let visibleCount = 0;

  housingUnits.forEach(function (housingUnit) {
    housingUnit.style.display = "none";
  });

  button.addEventListener("click", function () {
    if (visibleCount < 10) {
      housingUnits[visibleCount].style.display = "";
      visibleCount++;
    }

    if (visibleCount >= 10) {
      button.style.display = "none";
    }
  });
});
